const GRADES = ['Pre-K', 'K', '1', '2', '3', '4', '5', '6', '7', '8', '9', '10', '11', '12'];

const PAYMENT_OPTIONS = ['Mail Check', 'Will Pick Up Check', 'P-Card', 'Credit Card'];

const STATUSES = {
  DRIVER_ACCEPTANCE: {
    SELF_ACCEPTED: 2,
    ADMIN_ACCEPTED: 3,
    SELF_DECLINED: -1,
    ADMIN_DECLINED: -2,
  },
  TRIP_REQUEST: {
    DRAFT: 0,
    SUBMITTED: 1,
    COMPLETED: 2,
    RESUBMIT: -1,
    DENIED: -2,
    CANCELLED: -3,
    TRIPS_APPROVAL_DENIED: 2,
    TRIPS_APPROVAL_CHANGES_REQUESTED: 3,
  },
};

const VEHICLE_TYPES = {
  NORMAL: 0,
  RENTAL_DEALERSHIP: 1,
  CONTRACTOR: 2,
  APPROVED_CHARTER: 3,
  YELLOW_BUS: 4,
  get REGULAR_VEHICLE_TYPES() {
    return [VEHICLE_TYPES.NORMAL, VEHICLE_TYPES.YELLOW_BUS];
  },
  get ADDITIONAL_VEHICLE_TYPES() {
    return [VEHICLE_TYPES.RENTAL_DEALERSHIP, VEHICLE_TYPES.CONTRACTOR, VEHICLE_TYPES.APPROVED_CHARTER];
  },
};
const ASSIGNMENT_STATUS = {
  NONE: 0,
  PENDING: 1,
  SELF_ACCEPTED: 2,
  ADMIN_ACCEPTED: 3,
  SELF_DECLINED: -1,
  ADMIN_DECLINED: -2,
  NO_SHOW: -3,
  get DECLINED_STATUSES() {
    return [ASSIGNMENT_STATUS.ADMIN_DECLINED, ASSIGNMENT_STATUS.SELF_DECLINED, ASSIGNMENT_STATUS.NO_SHOW];
  },
};

const ASSIGNMENT_STATUS_MAP = {
  [ASSIGNMENT_STATUS.NONE]: 'No Driver Assigned',
  [ASSIGNMENT_STATUS.PENDING]: 'Pending',
  [ASSIGNMENT_STATUS.SELF_ACCEPTED]: 'Self Accepted',
  [ASSIGNMENT_STATUS.ADMIN_ACCEPTED]: 'Admin Accepted',
  [ASSIGNMENT_STATUS.SELF_DECLINED]: 'Self Declined',
  [ASSIGNMENT_STATUS.ADMIN_DECLINED]: 'Admin Declined',
  [ASSIGNMENT_STATUS.NO_SHOW]: 'No Show',
};

const CUSTOM_FORM_FIELDS_SECTIONS = {
  GENERAL: 0,
  LEAVERETURN: 1,
  DESTINATION: 2,
  ATTENDEES: 3,
  TRANSPORTATION: 4,
  FUNDING: 5,
  ADDITIONALINFO: 6,
  SUPPORTINGDOCUMENTS: 7,
};

const BASIC_TRIP_TYPES = {
  FIELD_TRIP: 1,
  ATHLETIC: 2,
  SPECIAL_NEEDS: 3,
  STAFF: 4,
};

const DASHBOARD_CARDS_CONFIG = {
  needsAttention: {
    vehicleOwner: false,
  },
  myUpcomingTrips: {
    vehicleOwner: false,
  },
  changesRequested: {
    vehicleOwner: false,
  },
};

module.exports = {
  GRADES,
  PAYMENT_OPTIONS,
  VEHICLE_TYPES,
  CUSTOM_FORM_FIELDS_SECTIONS,
  STATUSES,
  BASIC_TRIP_TYPES,
  ASSIGNMENT_STATUS,
  ASSIGNMENT_STATUS_MAP,
  DASHBOARD_CARDS_CONFIG,
};
